import LogoutIcon from "@mui/icons-material/Logout"
import { Box, Divider, Menu, MenuItem, Paper, Typography } from "@mui/material"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import "./index.css"
import TabsMenu from "./TabsMenu"
import { setUserData } from "../../redux/reducer/appReducer"
import ChangePasswordModal from "./ChangePasswordModal"
import { PROFILE, SETTINGS } from "../../utils/constants"
import EditProfileModal from "./EditProfileModal"

function ProfileMenu({ anchorEl, handleMenuClose, isMobile }) {
  const menuOpen = Boolean(anchorEl)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onClickLogout = () => {
    navigate("/", { replace: true })
    dispatch(setUserData({}))
    localStorage.clear()
  }

  const [selectedModal, setSelectedModal] = useState("")

  function RenderModal() {
    switch (selectedModal) {
      case SETTINGS:
        return <ChangePasswordModal selectedModal={selectedModal} setSelectedModal={setSelectedModal} />
      case PROFILE:
        return <EditProfileModal selectedModal={selectedModal} setSelectedModal={setSelectedModal} />
      default:
        return null
    }

  }

  let data = JSON.parse(localStorage.getItem("userData"))
  let name = data?.firstName + (data?.lastName ? (" " + data?.lastName) : "")
  // console.log("datadata123", data)


  return (
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={menuOpen}
      onClose={handleMenuClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            position: "absolute", // Position the menu below the image
            marginTop: "18px", // Space between the image and menu
            left: "50%", // Center the menu horizontally
            transform: "translateX(-50%)",
            top: "90px",
            width: "300px",
            // backgroundColor: "#f2f2f2",
            // padding: "0px", // Set padding to 0
            borderRadius: "10px", // Border radius for rounded corners
          },
        },
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      className="menu-container"
    >
      <Paper className="menu-paper" />

      <Box className="menu-box">
        <Box className="profile-header">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeJHWZvcQqXqBta04Ok3OjxguHy_hHXefxmI-uHBCjJIfx3pz2hUsFqkFSFBJgrHgE0og&usqp=CAU"
            alt={PROFILE}
            className="profile-image"
          />
          <div>
            <h1 className="profile-name">{name}</h1>
          </div>
        </Box>

        <Box className="menu-items">
          {isMobile && <TabsMenu isMobile={isMobile} />}
          <MenuItem className="menu-item" onClick={() => setSelectedModal(PROFILE)}>Profile</MenuItem>
          <MenuItem className="menu-item" onClick={() => setSelectedModal(SETTINGS)}>Settings</MenuItem>
          {selectedModal && <RenderModal />}
          <Divider />

          <MenuItem className="logout-item" onClick={onClickLogout}>
            <LogoutIcon />
            <Typography className="logout-text">Logout</Typography>
          </MenuItem>
        </Box>
      </Box>
    </Menu>
  )
}

export default ProfileMenu
